import httpClient from '../../httpClient';

export const updateOrderDeliveryStatus = (data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/order-deliveries/${data.orderDeliveryId}/status/update`,
    data,
  });
};
